import { useMemo } from 'react';

import { IconVerified } from 'ui-icons';

import { ThemeIcon } from '../../../../../DataDisplay/ThemeIcon';
import { Group } from '../../../../../Layout';
import { Divider } from '../../../../../Miscellaneous';
import { Text } from '../../../../../Typography';

const CauseDetail = ({
  city,
  state,
  website,
  withCheckmark,
}: {
  city?: string;
  state?: string;
  website?: string;
  /** Determines if the card should have a checkmark */
  withCheckmark?: boolean;
}) => {
  const addressString = useMemo(() => {
    if (!city && !state) return;
    if (city && state) {
      return `${city}, ${state}`;
    } else if (city && !state) {
      return `${city}`;
    } else if (!city && state) {
      return `${state}`;
    }
  }, [city, state]);

  const showDivider = useMemo(() => {
    return (city || state) && website;
  }, [city, state, website]);

  return (
    <Group gap="xs">
      {withCheckmark && (
        <ThemeIcon color="cobalt.5" variant="transparent" size="sm">
          <IconVerified size="16px" />
        </ThemeIcon>
      )}
      {(city || state) && (
        <Text fz={11} c="gray">
          {addressString}
        </Text>
      )}
      {showDivider && <Divider orientation="vertical" />}

      {website && (
        <Text fz={11} c="gray">
          {website}
        </Text>
      )}
    </Group>
  );
};

export { CauseDetail };
